import React from 'react';
import { Translate } from 'core/translate';
import { TotalLine } from './Lines';
import IntlContext from '../../common/intl/IntlContext';
import { PriceWithConditionalNotification } from './Price';
import { invert } from './utils';
import MathBoxGroup from './MathBoxGroup';

const EVIncentivesGroup = ({ pricing }) => {
  const { evIncentiveAfterTax, evIncentiveBeforeTax } = pricing;

  if (!evIncentiveAfterTax) {
    return null;
  }

  return (
    <MathBoxGroup>
      <TotalLine
        label={
          <IntlContext.Consumer>
            {({ currency }) => (
              <Translate
                value="component.pricing.ev.label"
                context={{ value: currency(evIncentiveAfterTax) }}
              />
            )}
          </IntlContext.Consumer>
        }
        price={
          <PriceWithConditionalNotification
            value={invert(evIncentiveBeforeTax)}
            notificationName="ev"
          />
        }
      />
    </MathBoxGroup>
  );
};

export default EVIncentivesGroup;
